import { useState } from "react";
import { CalendarClock, Eye, Trash } from "lucide-react";
import { ContainerCard, ModuleTitleCard } from "../../components/ui/cards";
import { Reactable } from "../../components/ui/reactable";
import { ROSTERING_GET } from "../../constants/api";
import { checkUserPermissionFunc } from "../../components/common/CommonFunctions";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import { cn } from "../../utils/tailwindUtils";
import useApiMethods from "../../lib/useApiMethods";
import ToastMsg from "../../components/common/ToastMsg";

const Roster = () => {

    const [rosterData, setRosterData] = useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [serverTrigger, setServerTrigger] = useState(false)
    let navigate = useNavigate()
    const { update } = useApiMethods()
    const { edit: editPermission, add: addPermission } = checkUserPermissionFunc("Roster", null, "Menu");

    const rosterColumns = [
        {
            accessor: 'from_date',
            Header: 'From Date',
            Cell: ({ value }) => value ?? "-"
        },
        {
            accessor: 'to_date',
            Header: 'To Date',
            Cell: ({ value }) => value ?? "-"
        },
        {
            accessor: 'total_shift',
            Header: 'Total shift',
            Cell: ({ value }) => value ?? "-"
        },
        {
            accessor: 'total_employees',
            Header: 'Total Employee',
            Cell: ({ value }) => value ?? "-"
        },
        {
            accessor: 'is_published',
            Header: 'Publish Status',
            Cell: ({ value }) => (
                <span
                    className={cn(
                        "px-2 py-1 text-xs font-medium rounded-full",
                        value
                            ? "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300"
                            : "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300"
                    )}
                >
                    {value ? "Published" : "Saved"}
                </span>
            ),
        },
        ...(editPermission ? [
            {
                accessor: 'action',
                Header: 'Action',
                Cell: ({ value, row }) => {

                    const handleOpenEdit = () => {
                        navigate('/roster/add', {
                            state: {
                                roster_id: row?.roster_id,
                                roster_from_date: row?.from_date,
                                roster_to_date: row?.to_date,
                                editAccess: editPermission,
                            }
                        });
                    }

                    const handleDelete = async () => {
                        try {
                            let payload = {
                                roster_id: row?.roster_id,
                                is_active: false,
                            }

                            const response = await update(ROSTERING_GET, payload)

                            if (response.status === 'success') {
                                ToastMsg('success', response.message)
                                setServerTrigger(true)
                            } else {
                                ToastMsg('error', response.message)
                            }
                        } catch (error) {
                            ToastMsg('success', error.message)
                        }
                    }

                    return (
                        <div className="flex items-center gap-2">
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={handleOpenEdit}
                            >
                                <Eye className="h-4 w-4" />
                            </Button>
                            {
                                row.is_published === false && (
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        className="text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/30"
                                        onClick={handleDelete}
                                    >
                                        <Trash className="h-4 w-4" />
                                    </Button>
                                )
                            }
                        </div>
                    )
                }
            }
        ] : [])
    ]

    const handleRosterOpen = () => {
        navigate("/roster/add")
    }

    return (
        <ContainerCard>
            <ModuleTitleCard
                Icon={CalendarClock}
                title={"Roster"}
                subtitle={"Defining the Roster attendance"}
                buttonEnable={!!addPermission}
                buttonName="Add Roster"
                totalRecords={totalRecords}
                setOpenDialog={handleRosterOpen}
            />

            <Reactable
                columns={rosterColumns}
                data={rosterData}
                setData={setRosterData}
                setTotalCount={setTotalRecords}
                serverSide={true}
                serverTrigger={serverTrigger}
                url={ROSTERING_GET}
                tableHeight="calc(100vh - 320px)"
                rowSize={editPermission ? "sm" : null}
                isCSVRequired
                isPDFRequired
            />
        </ContainerCard>
    )
}

export default Roster;